<template>
  <admin-base
    add-btn-text="Add New Group"
    :add-btn-permission="addGroupPermission"
    @create="showModalForm"
    @search="val => search = val"
  >
    <admin-groups-table
      ref="table"
      :search="search"
      @edit="showModalForm"
      @delete="deleteGroup"
    />
    <admin-groups-delete-modal
      ref="deleteModal"
      @success="refreshTable"
    />
    <admin-groups-modal-form
      ref="modalForm"
      @success="refreshTable"
    />
  </admin-base>
</template>

<script>
import AdminBase from '@/components/admin/Base';
import AdminGroupsTable from '@/components/admin/controls/groups/GroupsTable';
import AdminGroupsDeleteModal from '@/components/admin/controls/groups/DeleteModal';
import AdminGroupsModalForm from '@/components/admin/controls/groups/form/GroupsModalForm';


export default {
  name: 'AdminControlsGroupsView',
  components: {
    AdminBase,
    AdminGroupsTable,
    AdminGroupsDeleteModal,
    AdminGroupsModalForm,
  },
  data: () => ({
    search: null,
  }),
  computed: {
    addGroupPermission: vm => vm.$permissions.ADD_GROUPS,
  },
  methods: {
    showModalForm(group) {
      this.$refs.modalForm.open(this.$utils.deepCopy(group));
    },
    deleteGroup(group) {
      this.$refs.deleteModal.open(group);
    },
    refreshTable() {
      this.$refs.table.fetch();
    },
  },
};
</script>
